module.exports = __webpack_public_path__ + "img/pin-barrera.b91fc3fc.png";